/**
 * FxEditor/utilities/expressions.js
 * desc: pure helpers for data-expression strings — building, detecting, and parsing
 *       pill references like `data['com_ymeadows_constants']['<uuid>']`.
 * note: no React imports here so this module can be consumed by reducers and other
 *       store-side code without creating an import cycle with `FxEditor/utilities` →
 *       Label → store/actions.
 */
'use strict';

// Prefix used inside expressions for each pill data namespace. Shared with consumers
// that detect/build pill references (e.g. ReplaceExpressionTemplate, ExpressionReplace)
// so adding a fourth pill type only requires editing this map.
export const YM_DATA_PREFIX = {
    constant: 'com_ymeadows_constants',
    variable: 'com_ymeadows_variables',
    environment: 'com_ymeadows_environment',
};

export const buildDataExpression = (dataType, id) => `data['${YM_DATA_PREFIX[dataType]}']['${id}']`;

// True when `v` is a single full data-expression pill reference (e.g. an env field id
// passed through a resource picker). Used at save/read boundaries that need to branch
// between raw uuids and pill expressions.
export const isDataExpression = (v) => typeof v === 'string' && v.startsWith("data[");

// Pulls the uuid out of a pill expression like `data['com_ymeadows_constants']['<uuid>']`.
// Assumes the input is a single full pill reference; for parsing pills out of a larger
// expression, use getLabelPositions instead.
export const extractPillId = (pillExpression) =>
    pillExpression.substring(pillExpression.lastIndexOf('[') + 2, pillExpression.lastIndexOf(']') - 1);
